import { IconProps } from "@/components/Icons/index";

export const ExplorerLogo: React.FC<IconProps> = (props) => (
  <img src="/assets/images/explorer.png" alt="explorer" {...props} />
);
